import upload from './methods/upload.js'
import download from './methods/download.js'
import components from './components'

const Uploader = {
  install (Vue, options) {
    for (let name in components) {
      Vue.component(name, components[name])
    }

    Vue.prototype.$upload = upload
    Vue.prototype.$download = download
  }
}

export default Uploader



// WEBPACK FOOTER //
// ./src/plugins/uploader/index.js